import { render, staticRenderFns } from "./StudentTable.vue?vue&type=template&id=7d5d773e&scoped=true&"
import script from "./StudentTable.vue?vue&type=script&lang=js&"
export * from "./StudentTable.vue?vue&type=script&lang=js&"
import style0 from "./StudentTable.vue?vue&type=style&index=0&id=7d5d773e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5d773e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDataTable,VDivider})
